<template>
    <v-container fluid>
      <v-snackbar
        v-model="snackbar"
        :color="snackbarColor"
        :top="true"
        :right="true"
        :timeout="-1"
        absolute
      >
        {{ message }}
        <v-btn
          dark
          text
          @click="snackbar = false"
        >
          CLOSE
        </v-btn>
      </v-snackbar>
      <v-row>
        <v-progress-circular v-show="approveloading || declineloading" color="secondary"
                class="accent--text logoutbtn" size="25"
                             indeterminate></v-progress-circular>
        <v-spacer></v-spacer>
        <v-row no-gutters justify="space-around" class="mb-4 mt-4">
  <v-col  class="d-flex justify-end">
    <v-btn color="#7BC243" @click="createCherrysRecordDialog"   v-if="$can('CAN_UPLOAD_FARMERS')" class="white--text cataloguebtn">
      Create Cherry
    </v-btn>
  </v-col>
</v-row>
      </v-row>
      <v-layout>
        <v-flex xs12>
          <div :class="farmerCherryList.length === 7 ? 'limits_box' : 'limits_box_empty'">
            <v-card-text>
                <v-layout>
                <v-flex xs3>
                  <span class="accent--text" style="font-size: 14px; font-weight:700;">  Cherry View/Update </span>
                </v-flex>
                <v-flex xs3>
                  <span class="accent--text" style="font-size: 14px; font-weight:700;">  {{ organisationName }} </span>
                </v-flex>
                <v-spacer>
                </v-spacer>
              </v-layout>
              <v-layout row wrap mt-2 align-center>
                    <v-flex xs2>
                   TOTAL CHERRY WEIGHT
                    <v-text-field
                        v-model="totalWeight"
                        readonly
                    ></v-text-field>
                    </v-flex>

                    <v-flex xs2>
                    <!-- <v-btn
                        class="primary"
                        style="min-width: auto; padding: 0 8px; height: auto; font-size: 16px;"
                        @click="exportToExcel"
                    >
                        Download
                    </v-btn> -->
                    </v-flex>
                    <v-flex xs2>
                    <!-- <v-btn
                        class="primary"
                        style="min-width: auto; padding: 0 8px; height: auto; font-size: 16px;"
                        @click="exportToExcel"
                    >
                        Download
                    </v-btn> -->
                    </v-flex>
                      <v-flex  xs2>
                      <v-btn
                        xs2
                        small
                        @click="exportToExcel"
                        v-if="$can('CAN_UPLOAD_FARMERS') || $can('CAN_APPROVE_FARMERS')"
                        class="ml-2"
                        outlined
                      >
                        Download
                        <v-icon small class="ml-2">mdi-download</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex xs3>
                    <v-text-field
                        label="Search"
                        v-model="search"
                    ></v-text-field>
                    </v-flex>
                </v-layout>
              <v-data-table
                :headers="headers"
                :items="farmerCherryList"
                :pagination.sync="pagination"
                :total-items="totalCharges"
                :loading="loading"
                :search="search"
                class="elevation-1"
              >
                <!-- Header formatting -->
                <template v-slot:headerCell="{ header }">
                  <span class="body-2 font-weight-regular accent--text">{{ header.text }}</span>
                </template>
                <template v-slot:item="props">
                  <tr>
                    <td>{{ props.item.memberNumber }}</td>
                    <td>{{ props.item.fullName }}</td>
                    <td>{{ props.item.growerCode }}</td>
                    <td>{{ props.item.productName }}</td>
                    <td>{{ props.item.currentDelivery }}</td>
                    <td>{{ props.item.season }}</td>
                    <td>{{ props.item.idNumber }}</td>
                    <td>{{ props.item.status }}</td>
                    <td class="actions">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
               <v-btn
                color="primary"
                dark
                v-on="on"
                text
                icon
                class="actions"
              >
                <v-icon class="secondary--text"> more_horiz </v-icon>
              </v-btn>
              </template>
              <v-list>
                <v-list-item  v-if="$can('CAN_UPLOAD_FARMERS')" @click="showEditDialog(props.item, 'edit')">
                  <v-list-item-title> Edit </v-list-item-title>
                </v-list-item>
                <v-list-item  v-if="$can('CAN_APPROVE_FARMERS')"  @click="confirmAction(props.item, 'approve')">
                  <v-list-item-title> Approve </v-list-item-title>
                </v-list-item>
                <v-list-item v-if="$can('CAN_APPROVE_FARMERS')" @click="confirmAction(props.item, 'decline')">
                  <v-list-item-title> Decline </v-list-item-title>
                </v-list-item>
                <!-- <v-list-item v-if="$can('CAN_UPLOAD_FARMERS') || $can('CAN_APPROVE_FARMERS')" @click="exportToExcel">
                  <v-list-item-title> Download  </v-list-item-title>
                </v-list-item> -->
              </v-list>
            </v-menu>
          </td>
                      <!-- <v-list class="d-flex flex-row">
                        <v-list-item v-if=" $can('CAN_APPROVE_CHERRY_RATE')" @click="exportToExcel">
                          <v-list-item-title><v-icon>mdi-eye</v-icon></v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if=" $can('CAN_APPROVE_CHERRY_RATE')"  @click="confirmAction(props.item, 'approve')">
                          <v-list-item-title > <v-icon>mdi-check-circle</v-icon></v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if=" $can('CAN_APPROVE_CHERRY_RATE')"  @click="confirmAction(props.item, 'decline')">
                          <v-list-item-title>mdi-cancel</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="canUploadLimits" @click="showEditDialog(props.item, 'edit')">
                          <v-list-item-title><v-icon>mdi-pencil</v-icon></v-list-item-title>
                        </v-list-item>
                         <v-list-item v-if="canUploadLimits" @click="exportToExcel">
                          <v-list-item-title><v-icon>mdi-download</v-icon></v-list-item-title>
                        </v-list-item>
                      </v-list> -->

                  </tr>
                </template>

                <!-- No data slot -->
                <template v-slot:no-data>
                  <p>No data found</p>
                  <v-btn color="primary" @click="getDataFromApi">Reload</v-btn>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
              <v-spacer></v-spacer>
              <v-pagination
                v-model="page"
                :length="numberOfLinks"
                color="secondary"
                class="accent--text logoutbtn"
              ></v-pagination>
            </v-card-actions>
          </div>
        </v-flex>
        <v-dialog v-model="confirmDialog" max-width="500">
          <v-card>
            <v-card-title class="headline accent--text text-capitalize">{{ this.action }} Cherry Details</v-card-title>
            <v-card-text>
              <v-flex xs12>
                <p class="font-weight-regular subheading"> {{ confirmMessage }} </p>
              </v-flex>
            </v-card-text>

            <v-card-actions>
              <v-btn
                color="primary"
                text
                @click="confirmDialog = false"
                class="font-weight-bold"
              >
                Cancel
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="secondary"
                class="white--text logoutbtn"
                @click="approveOrDecline(confirmCherry)"
              >
                Confirm
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="createCherryRecordDialog" persistent max-width="800">
          <v-card>
            <v-card-title class="headline accent--text">Create Cherry Record</v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                  <v-row>
                <v-col cols="12"  md="6">
                     <v-autocomplete
                    v-model="memberNumber"
                    :items="farmerItems"
                    :loading="loading"
                    :search-input.sync="searchQuery"
                    :rules="[v => !!v || 'Member Number is required']"
                    item-text="memberNumber"
                    item-value="memberNumber"
                    label="MEMBER NUMBER"
                    placeholder="Start typing to search"
                    clearable
                    required
                    @update:search-input="onSearchInput"
                  >
                    <template v-slot:selection="{ item }">
                      <span>{{ item.memberNumber }}</span>
                    </template>
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title>{{ item.memberNumber }} </v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12"  md="6">
                  <v-text-field
                    v-model="fullName"
                    label="FULL NAME"
                    required
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12"  md="6">
                  <v-text-field
                  type="number"
                    v-model="idNumber"
                    label="ID NUMBER"
                    required
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12"  md="6">
                    <!-- <v-select
                        label="Grower"
                        item-text="name"
                        item-value="value"
                        class="w-100"
                        v-model="grower"
                        :items="growerCodes"
                        variant="solo-filled"
                        hide-checkoffSettlementDetails
                        return-object
                        style="height: 60px; font-size: 16px;"
                    /> -->
                    <v-text-field label="Grower" :rules="[v => !!v || 'Grower ID is required']" v-model="grower" required></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12"  md="6">
                  <v-select
                        label="PRODUCE NAME"
                        item-text="name"
                        item-value="value"
                        :rules="[v => !!v || 'Product Name is required']"
                        class="w-100"
                        v-model="productName"
                        :items="['COFFEE']"
                        variant="solo-filled"
                        hide-details
                        return-object
                        style="height: 60px; font-size: 16px;"
                        required
                    />
                </v-col>
                <v-col cols="12"  md="6">
                    <v-text-field
                        label="CURRENT DELIVERY (KGS)"
                        v-model="currentDelivery"
                        :rules="[v => !!v || 'Current Delivery is required']"
                        type="number"
                        required
                        ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12"  md="6">
                    <v-select
                        label="Season"
                        item-text="name"
                        item-value="value"
                        :rules="[v => !!v || 'Season is required']"
                        class="w-100"
                        v-model="season"
                        :items="seasons"
                        variant="solo-filled"
                        hide-details
                        return-object
                        style="height: 60px; font-size: 16px;"
                        required
                    />
                </v-col>
              </v-row>
              </v-form>
            </v-card-text>
            <v-row>
            <v-checkbox
              v-model="disclaimerAccepted"
              :label="'I confirm that the data provided is correct and is reliable for use by the DSS to process and utilize for processing payments in line with the third schedule and applicable clauses of the Crop Coffee General Regulations 2019.'"
              color="primary"
              :rules="[v => !!v || 'Please tick the checkbox to proceed']"
              required
            ></v-checkbox>

            <small class="text--secondary">
              <strong>Note:</strong> To ensure that entities and their users understand their roles and responsibilities regarding the data they provide, they must acknowledge the following disclaimer by ticking the box above.
            </small>
          </v-row>
            <v-card-actions>
              <v-btn color="white" class="accentd--text" style="font-weight: 700;" @click="cancelCherrysRecordDialog">Cancel
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn color="secondary" @click="createCherryRecord" :loading="loading">CREATE</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="editDialog" persistent max-width="800">
  <v-card>
    <v-card-title class="headline accent--text">Edit Cherry Record</v-card-title>
    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="memberNumber"
              label="MEMBER NUMBER"
              :rules="[v => !!v || 'Member Number is required']"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="fullName"
              label="FULL NAME"
              :rules="[v => !!v || 'Full Name is required']"
              required
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              type="number"
              v-model="idNumberEdit"
              label="ID NUMBER"
              :rules="[
                v => !!v || 'ID Number is required',
                v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero'
              ]"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="growerEdit"
              label="Grower"
              :rules="[v => !!v || 'Grower is required']"
              required
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-select
              label="PRODUCE NAME"
              v-model="productName"
              :items="['COFFEE']"
              item-text="name"
              item-value="value"
              variant="solo-filled"
              hide-details
              return-object
              style="height: 60px; font-size: 16px;"
              :rules="[v => !!v || 'Product Name is required']"
              required
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              label="CURRENT DELIVERY (KGS)"
              v-model="currentDelivery"
              type="number"
              :rules="[
                v => !!v || 'Current Delivery is required',
                v => /^\d+$/.test(v) && parseInt(v) > 0 || 'Enter a number greater than zero'
              ]"
              required
            ></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-select
              label="Season"
              v-model="season"
              :items="seasons"
              item-text="name"
              item-value="value"
              variant="solo-filled"
              hide-details
              return-object
              style="height: 60px; font-size: 16px;"
              :rules="[v => !!v || 'Season is required']"
              required
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn color="white" class="accentd--text" style="font-weight: 700;" @click="cancelEditCherrysRecordDialog">
        Cancel
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="secondary" @click="editCherryRecord" :loading="loading">Update</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

      </v-layout>
    </v-container>
  </template>
  <script>
  import axios from 'axios'
  import config from '../../../config'
  import store from '../../../store'
  import { mapState } from 'vuex'
  import { Common } from '@/components/views/file/common'
  import * as XLSX from 'xlsx'
  import { saveAs } from 'file-saver'

  export default {
      name: 'cherrycreation',
      data: function () {
          return {
            headers: [
              { text: 'Member Number', value: 'memberNumber' },
							{ text: 'Member Name', value: 'fullName' },
              { text: 'Grower Code', value: 'growerCode' },
              { text: 'Crop', value: 'productName' },
              { text: 'Weight', value: 'currentDelivery' },
              { text: 'Season', value: 'season' },
							{ text: 'ID Number', value: 'idNumber' },
              { text: 'Status', value: 'status' }
						  ],
              previewItems: [],
              valid: true,
              message: '',
              snackbar: false,
              snackbarColor: '',
              file: '',
              farmercherry:{},
              files: [],
              seasons: [],
              status: [],
              editDialog: false,
              totalFiles: 0,
              totalWeight: 0,
              pagination: { sortBy: 'id', descending: true },
              loading: false,
              search: '',
              expand: false,
              permissions: [],
              previewLoading: false,
              approveloading: false,
              declineloading: false,
              farmerCherryList: [],
              exportFarmerCherryList: [],
              benefactors: [],
              numberOfLinks: 0,
              numberOfItemsPerPage: 7,
              page: 1,
              confirmDialog: false,
              confirmFile: {},
              confirmCherry: {},
              confirmMessage: '',
              action: '',
              uploadFileDialog: false,
              createCherryRecordDialog: false,
              editDialog: false,
              shareDataCheckbox: false,
              organisationType: '',
              organisationName: '',
              organisationId: '',
              currentYear: new Date(),
              valid: false,
              farmerResults: [],
              idNumberEdit:'',
              id:'',
              idNumber: 0,
              farmerId: '',
              fullName: '',
              memberNumber: '',
              grower: '',
              growerEdit: '',
              growerCodes: [],
              seasons: [],
              disclaimerAccepted:'',
              productName: '',
              currentDelivery: '',
              season: '',
              componentKey: 0,
              selectedFarmerId: null,
              searchQuery: null,
              loading: false,
              farmerItems: [],
              searchTimeout: null,
              editDialog: false,
              editMode: '',
              selectedItem: null,
              statusOptions: ['APPROVED','PENDING_APPROVAL'],
                }
      },
      mounted () {
        this.getDataFromApi()
      .then(data => {
        // this.users = data.items
        // this.totalUsers = data.total
      })
        this.getGrowerCodes()
		    this.getSeasons()
        this.getLoggedInUser ()
        // this.getCherryfarmer()
        this.getTotalWeight()
        this.permissions = store.state.user.roleId.permissions
      },
      watch: {
          memberNumber(newVal) {
      if (newVal) {
        // Emit the selected farmer ID to parent component
        this.$emit('input', newVal);

        // Find the complete farmer object and emit it
        const selectedFarmer = this.farmerItems.find(farmer => farmer.memberNumber  === newVal);
        if (selectedFarmer) {
          this.$emit('farmer-selected', selectedFarmer);
        }
      } else {
        this.$emit('input', null);
      }
    },
    pagination: {
      handler () {
        this.getDataFromApi()
          .then(data => {
            // this.users = data.items
            // this.totalUsers = data.total
          })
      },
      deep: true
    }


      },
      computed: {
          ...mapState([
              'userInfo', 'user'
          ]),
          canUploadLimits: function () {
              return this.hasPerm('CAN_UPLOAD_LIMITS')
          },
          canApproveCatalogue: function () {
              return this.hasPerm('CAN_APPROVE_CATALOGUE')
          },

          isAKPCUUser () {
              return this.user.organisation.organisationType.name === 'KPCU'
          },

          filteredFarmerCherryList() {
      if (!this.search) {
        return this.farmerCherryList;
      }

      const searchTerm = this.search.toLowerCase();
      return this.farmerCherryList.filter(item => {
        return (
          item.fullName.toLowerCase().includes(searchTerm) ||
          item.idNumber.toString().includes(searchTerm) ||
          item.growerCode.toLowerCase().includes(searchTerm) ||
          item.memberNumber.toString().includes(searchTerm) ||
          item.productName.toLowerCase().includes(searchTerm) ||
          item.season.toLowerCase().includes(searchTerm) ||
          item.status.toLowerCase().includes(searchTerm)
        );
      });
    }
      },
      methods: {
        getDataFromApi () {
      this.loading = true
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        let items = this.getCherryfarmer()
        const total = items.length

        if (this.pagination.sortBy) {
          items = items.sort((a, b) => {
            const sortA = a[sortBy]
            const sortB = b[sortBy]

            if (descending) {
              if (sortA < sortB) return 1
              if (sortA > sortB) return -1
              return 0
            } else {
              if (sortA < sortB) return -1
              if (sortA > sortB) return 1
              return 0
            }
          })
        }

        if (rowsPerPage > 0) {
          items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage)
        }

        setTimeout(() => {
          this.loading = false
          resolve({
            items,
            total
          })
        }, 1000)
      })
    },
          async onStatusChange(selectedValue) {
            try {

              const token = localStorage.getItem('token');
                        const tokenconfig = {
                            headers: {
                                Authorization: `Bearer ${token}`
                            }
                        };

              const response = await fetch(config.serverURI + `/farmercherry/farmer/status?status=${selectedValue}`, tokenconfig);

              const data = await response.json();

              console.log('FarmerCherryList data ==> ' + JSON.stringify(data));

            } catch (error) {
              console.error("Failed to fetch data:", error);
            }
          },
          getCherryfarmer() {
              const url = config.serverURI + '/farmercherry/'
              axios.get(url, {})
                .then(response => {
                  this.responseData = response.data
                  // console.log('Response data ===>' + JSON.stringify(this.responseData))
                            this.farmerCherryList = response.data
                })
                .catch(error => {
                  console.log('error', error.response)
                  this.message = error.response.status
                  this.snackbar = true
                  this.snackbarColor = 'error'
                })
              return this.farmerCherryList
          },

        confirmAction(item, action) {
          this.confirmCherry = { ...item };
          this.confirmDialog = true;
          this.action = action;
          console.log('ConfirmCherry==>'+ JSON.stringify(this.confirmCherry))
          if (action === 'approve') {
            this.confirmMessage = 'Approve Cherry Details ' + this.confirmCherry.fullName + '?';
          } else if (action === 'decline') {
            this.confirmMessage = 'Decline Cherry Details ' + this.confirmCherry.fullName + '?';
          } else {
            console.error(action + ' action not supported');
          }
        },

    async exportToExcel() {
      const url = config.serverURI + '/farmercherry/downloadcherry';

      try {
        const response = await axios.get(url);
        this.responseData = response.data;
        this.exportFarmerCherryList = response.data;

        // Ensure there's data to export
        if (!this.exportFarmerCherryList || this.exportFarmerCherryList.length === 0) {
          this.message = 'No data available to export.';
          this.snackbar = true;
          this.snackbarColor = 'warning';
          return;
        }

        // Proceed to generate the Excel file
        const worksheet = XLSX.utils.json_to_sheet(this.exportFarmerCherryList);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "FarmerCherry");

        const excelBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "array"
        });

        const blob = new Blob([excelBuffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        saveAs(blob, "farmer_cherry.xlsx");

        this.message = 'Excel file downloaded successfully!';
        this.snackbar = true;
        this.snackbarColor = 'success';

      } catch (error) {
        console.error("Export failed:", error);
        this.message = error.response?.status || 'Error occurred while exporting data';
        this.snackbar = true;
        this.snackbarColor = 'error';
      }
    },
        showEditDialog(item, mode) {
            this.selectedItem = { ...item };
            this.editMode = mode;
            this.editDialog = true;
            console.log('Edit ===>' + JSON.stringify(this.selectedItem ))
             this.farmerId = this.selectedItem.idNumber
            this.fullName = this.selectedItem.fullName
            this.memberNumber = this.selectedItem.memberNumber
            this.productName = this.selectedItem.productName
            this.currentDelivery = this.selectedItem.currentDelivery
            this.season = this.selectedItem.season
            this.idNumberEdit = this.selectedItem.idNumber
            this.grower = this.selectedItem.growerCode
            this.growerEdit = this.selectedItem.growerCode //this.growerCodes.find(item => item.value === this.grower)
            this.id = this.selectedItem.id

        },

        saveChanges() {
            const index = this.farmerCherryList.findIndex(f => f.id === this.selectedItem.id);
            if (index !== -1) {
                this.farmerCherryList.splice(index, 1, { ...this.selectedItem });
            }
            this.editDialog = false;
            },
                onSearchInput(val) {
            if (val && val.length > 2) {
              this.loading = true;
              // Debounce the search
              clearTimeout(this.searchTimeout);
              this.searchTimeout = setTimeout(() => {
                this.searchFarmers(val);
              }, 300);
            }
          },
            reloadComponent() {
              this.componentKey += 1;
            },
            async searchFarmers(query) {
              try {
                  this.loading = true;

                  const token = localStorage.getItem('token');
                  const tokenconfig = {
                      headers: {
                          Authorization: `Bearer ${token}`
                      }
                  };

                  const response = await fetch(config.serverURI + `/farmercherry/farmer?memberNumber=${query}`, tokenconfig);
                  if (!response.ok) {
                      throw new Error(`API request failed with status ${response.status}`);
                  }
                  const data = await response.json();
                  console.log('Response Data ==> ', data);
                  this.idNumber = `${data.idNumber || ''} `.trim();
                  this.fullName = `${data.fullName || ''} `.trim();
                  this.memberNumber = `${data.memberNumber || ''} `.trim();
                  this.farmerId = `${data.farmerId || ''} `.trim();
                  this.grower =   `${data.grower || ''} `.trim();
                  this.productName = 'COFFEE';
                  this.currentDelivery = 0.00;

                  this.farmerItems = [data]; // Store the single object as an array

                  // if (data.growerCode !== null) {
                  //     this.grower = data.growerCode;
                  // }

              } catch (error) {
                  console.error('Error fetching farmer data:', error);
                  this.$emit('error', error.message);
              } finally {
                  this.loading = false;
              }
          },
            getCherryfarmer() {
              const url = config.serverURI + '/farmercherry/'
              axios.get(url, {})
                .then(response => {
                  this.responseData = response.data
                  // console.log('Response data ===>' + JSON.stringify(this.responseData))
                            this.farmerCherryList = response.data
                })
                .catch(error => {
                  console.log('error', error.response)
                  this.message = error.response.status
                  this.snackbar = true
                  this.snackbarColor = 'error'
                })
              return this.farmerCherryList
          },
        getTotalWeight() {
			const url = config.serverURI + '/farmercherry/totalweight'
			axios.get(url, {})
				.then(response => {
					this.responseData = response.data
                    this.totalWeight = response.data
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
			return this.totalWeight
		},

          getLoggedInUser () {
			this.theUser = JSON.parse(localStorage.getItem('user'))
			console.log('user ===>> ', this.theUser)
			this.organisationType = this.theUser.organisation.organisationType.name
			this.organisationId = this.theUser.organisation.id
			// this.curUserN = this.curUser.firstName
		},

          getSeasons () {
			this.seasons.push('2023/2024')
			const month = this.currentYear.getMonth()
			const year = this.currentYear.getFullYear()
			if (month < 10) {
        this.seasons.push((year - 1) + '/' + (year ))
				this.seasons.push(year + '/' + (year + 1))
				this.seasons.push(year + 1 + '/' + (year + 2))
			} else {
				this.seasons.push(year + 1 + '/' + (year + 2))
				this.seasons.push(year + 3 + '/' + (year + 4))
			}
		},

		getGrowerCodes () {
			const url = config.serverURI + '/organization/get-marketers'
			axios.get(url)
				.then(response => {
					console.log('FCS - ', response.data)
					// this.growerCodes = response.data
					response.data.forEach(x => {
						// console.log('->> ', x.organisationCode)
						this.growerCodes.push(x.organisationCode)
					})
				})
				.catch(error => {
					// Request failed.
					console.log('error', error.response)
					this.message = error.response.status
					this.snackbar = true
					this.snackbarColor = 'error'
				})
			return this.growerCodes
		   },

          canBeApproved (item) {
              if (item.status === null) {
                  return false
              }
              return (item.status.id === 19 || item.status.id === 18) && this.hasPerm('CAN_APPROVE_LIMITS')
          },
          canBeApprovedKPCU (item) {
              if (item.status === null) {
                  return false
              }
              return (item.status.id === 17) && this.hasPerm('CAN_APPROVE_LIMITS') && this.user.organisation.organisationType.id === 10
          },
          canBeDeclined (item) {
              if (item.status === null) {
                  return false
              }
              return (item.status.id === 19 || item.status.id === 18) && this.hasPerm('CAN_APPROVE_LIMITS')
          },
          canBeDeclinedKPCU (item) {
              if (item.status === null) {
                  return false
              }
              return (item.status.id === 17) && this.hasPerm('CAN_APPROVE_LIMITS') && this.user.organisation.organisationType.id === 10
          },
          paginationMethod (items, pageNumber, limitPerPage) {
              pageNumber = pageNumber - 1
              const from = pageNumber * limitPerPage
              let to = (pageNumber + 1) * limitPerPage
              if (to >= items.length) {
                  to = items.length
              }
              return items.slice(from, to)
          },
          hasPerm (permission) {
              return this.permissions.includes(permission)
          },
          handleFileUpload () {
              this.file = this.$refs.file.files[0]
          },
          approveOrDecline (item) {
              if (this.action === 'approve') {
                  this.approve(item)
              } else if (this.action === 'decline') {
                  this.decline(item)
              } else {
                  console.error('Function not supported')
              }
          },
          uploadFarmersDialog () {
              this.uploadFileDialog = true
          },
          editCherrysRecordDialog(){
              this.editDialog = true
          },
          cancelEditCherrysRecordDialog () {
              this.editDialog = false
              this.$refs.form.reset()
              this.$refs.file.value = null
          },
          createCherrysRecordDialog(){
              this.createCherryRecordDialog = true
          },
          cancelCherrysRecordDialog () {
              this.createCherryRecordDialog = false
              this.$refs.form.reset()
              this.$refs.file.value = null
          },
          cancelFileUpload () {
              this.uploadFileDialog = false
              this.$refs.form.reset()
              this.$refs.file.value = null
          },
          approve (item) {
            this.approveloading = true
            const payload = {
                    action: 'approve',
                    confirmCherry: this.confirmCherry
                    };
                console.log('Form Data:', payload);
                axios.post(config.serverURI + '/farmercherry/approve', payload)
                    .then(response => {
                        console.log('Form submitted:', response.data);
                        this.editDialog = false
                        this.getCherryfarmer()
                        this.$router.go()
                         this.message = 'Cherry Approved successfully!'
                  this.snackbar = true
                  this.snackbarColor = 'success'
                    })
                    .catch(error => {
                        console.error('Submission error:', error);
                    });
          },
          decline (item) {
            this.declineloading = true
            const payload = {
                    action: 'decline',
                    confirmCherry: this.confirmCherry
                    };
                console.log('Form Data:', payload);
                axios.post(config.serverURI + '/farmercherry/approve', payload)
                    .then(response => {
                        console.log('Form submitted:', response.data);
                        this.editDialog = false
                        this.$router.go()
                        this.reloadComponent()
                        this.getCherryfarmer()
                        this.message = 'Cherry Approved Declined successfully!'
                  this.snackbar = true
                  this.snackbarColor = 'success'
                    })
                    .catch(error => {
                        console.error('Submission error:', error);
                    });
           },
          async editCherryRecord() {
            if (this.$refs.form.validate()) {
                const payload = {
                    id: this.id,
                    idNumber: this.idNumberEdit,
                    fullName: this.fullName,
                    memberNumber: this.memberNumber,
                    growerCode: this.growerEdit,
                    productName: 'COFFEE',//this.productName.name,
                    currentDelivery: this.currentDelivery,
                    season: this.season,
                    status: 'PENDING_APPROVAL'
                    };
                console.log('Form Data:', payload);

                axios.post(config.serverURI + '/farmercherry/update', payload)
                .then(response => {
                    console.log('Form submitted:', response.data);
                    this.editDialog = false
                    this.$router.go()
                    this.reloadComponent()
                    this.getCherryfarmer()
                    this.message = 'Cherry Record Updated successfully!'
                  this.snackbar = true
                  this.snackbarColor = 'success'
                })
                .catch(error => {
                    console.error('Submission error:', error);
                });
            } else {
                console.warn('Form is invalid');
            }
           },
           createCherryRecord() {
  // Trigger form validation (returns true if valid)
  if (this.$refs.form.validate()) {
    const formData = {
      idNumber: this.idNumber,
      fullName: this.fullName,
      memberNumber: this.memberNumber,
      growerCode: this.grower,
      productName: this.productName,
      currentDelivery: this.currentDelivery,
      season: this.season,
      status: 'PENDING_APPROVAL'
    };

    console.log('Form Data:', formData);

    axios.post(config.serverURI + '/farmercherry/', formData)
      .then(response => {
        console.log('Form submitted:', response.data);
        this.createCherryRecordDialog = false;
        this.message = 'Cherry Record Created successfully!';
        this.snackbar = true;
        this.snackbarColor = 'success';
        this.$router.go();
        this.reloadComponent();
        this.getCherryfarmer();

      })
      .catch(error => {
        console.error('Submission error:', error);
        this.message = 'Failed to create record.';
        this.snackbar = true;
        this.snackbarColor = 'error';
      });
  } else {
    console.warn('Form is invalid');
    this.message = 'Please fix the errors before submitting.';
    this.snackbar = true;
    this.snackbarColor = 'warning';
  }
}
        //   createCherryRecord() {
        //     if (this.$refs.form.validate()) {
        //         const formData = {
        //             idNumber: this.idNumber,
        //             fullName: this.fullName,
        //             memberNumber: this.memberNumber,
        //             growerCode: this.grower,
        //             productName: this.productName,
        //             currentDelivery: this.currentDelivery,
        //             season: this.season,
        //             status: 'PENDING_APPROVAL'
        //         };
        //         console.log('Form Data:', formData);

        //         axios.post(config.serverURI + '/farmercherry/', formData)
        //         .then(response => {
        //             console.log('Form submitted:', response.data);
        //             this.createCherryRecordDialog = false
        //             this.$router.go()
        //             this.reloadComponent()
        //             this.getCherryfarmer()
        //             this.message = 'Cherry Record Created successfully!'
        //           this.snackbar = true
        //           this.snackbarColor = 'success'
        //         })
        //         .catch(error => {
        //             console.error('Submission error:', error);
        //         });
        //     } else {
        //         console.warn('Form is invalid');
        //     }
        // }

      }
  }

  </script>
  <style>
  .limits_box_empty {
    position: relative;
    background: #fff;
    border: 1px solid #707070;
  }

  .limits_box {
    position: relative;
    background: #fff;
    border: 1px solid #707070;
  }

  /*.catalogue_box:after, .catalogue_box:before {
    right: 100%;
    top: 17%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  .catalogue_box:after {
    border-color: rgba(255, 255, 255, 0);
    border-right-color: #fff;
    border-width: 20px;
    margin-top: -20px;
  }
  .catalogue_box:before {
    border-color: rgba(112, 112, 112, 0);
    border-right-color: #707070;
    border-width: 21px;
    margin-top: -21px;
  }*/

  .thead {
    background-color: #00513B !important;
    color: white;
    font-size: 12px;
  }

  .table tbody tr > td.actions {
    font-size: 20px !important;
    color: #733D29 !important;
    padding-top: 0px;
  }

  .pagination {
    background-color: red;
  }

  .paginationtext {
    color: #733D29;
  }

  .pagination > li > a,
  .pagination > li > span {
    border: 1px solid #F2D0A7;
    color: #733D29;
  }

  .pagination > li.active > .page-link {
    background: #00513B;
    color: #fff;
  }
  </style>
